import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { registerUser } from "./authServices";
import { doc, setDoc, Timestamp } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import { db } from "../../Firebase";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import "./Inscription.css";
import { CONNEXION_NAVIGATION } from "../../Routes/NAVIGATION_PATH";
import { AiFillEye } from "react-icons/ai";
import { FaEyeSlash } from "react-icons/fa";

export default function Inscription() {
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShowns, setPasswordShowns] = useState(false);
  
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);

  };
  
  const togglePasswordVisiblitys = () => {
    setPasswordShowns(passwordShowns ? false : true);

  };
  
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const onSubmit = (data) => {
    const { nom, prenom, email, confirmPassword, password } = data;
    if (confirmPassword === password) {
      registerUser(email, password)
        .then((userCredential) => {
          toast.success("Admin crée avec succès!");
          const user = userCredential.user;
          setDoc(doc(db, "users", user.uid), {
            prenom: prenom,
            nom: nom,
            email: email,
            user_type: "admin",
            registeredAt: Timestamp.fromDate(new Date()),
          });
          navigate("/");
        })
        .catch((error) => {
          const errorCode = error.code;
          if (errorCode === 'auth/email-already-in-use') {
            toast.error("Utilisateur existant !");
            reset();
          }else if(errorCode === 'auth/weak-password'){
            toast.warning("Mot de passe faible, utlisez minimum 6 caractères !")
          }else if(errorCode === 'email-already-in-use'){
            toast.warning("Email déjà utiliser !")
          }else if(errorCode === "auth/invalid-email"){
            toast.error("Adresse Email non valide !")
          }
        });
    } else {
      toast.error("Mots de passe ne correspond pas");
    }
  };

  return (
    <div className="container-fluid inscription d-flex justify-content-center align-items-center min-vh-100 flex-column">
      <div className="row my-contenar">
        <div className="text-center">
          <div className="container-logo">
            <h2>Admin Inscription</h2>
            <p>
              vous avez déjà un compte ?
              <Link to = {'/'} className="SpanEnre">Connectez-vous !</Link>
            </p>
          </div>
        </div>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="" controlId="formBasicEmail">
            <Form.Label> Nom</Form.Label>
            <Form.Control type="text" placeholder="nom"
             {...register("nom", {
                        required: true,
                        maxLength: 15,
                        pattern: /^[A-Za-z\s]+$/i
                      })}
                    />
                    {errors?.nom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                    {errors?.nom?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 15 lettres</p> 
                    )}
                    {errors?.nom?.type === "pattern" && (
                      <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                    )}
          </Form.Group>
          <Form.Group className="" controlId="formBasicEmail">
            <Form.Label> Prenom</Form.Label>
            <Form.Control
              {...register("prenom", {
                        require: true,
                        maxLength: 25,
                        pattern: /^[A-Za-z\s]+$/i
                      })}
                      type="text"
                      placeholder="Prénom"
                    />
                    {errors?.prenom?.type === "required" && <p className="text-danger">C'est champs est obligatoire</p>}
                    {errors?.prenom?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 25 lettres</p>
                    )}
                    {errors?.prenom?.type === "pattern" && (
                      <p className="text-danger">Il ne prend que des lettres alphabétiques </p>
                    )}
          </Form.Group>
          <Form.Group className="" controlId="formBasicEmail">
            <Form.Label>Adresse email </Form.Label>
            <Form.Control
              {...register("email", {
                        require: true, maxLength: 25,
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                      })}
                      type="email"
                      placeholder="Entrez votre mail"
                    />
                    {errors?.email?.type === "maxLength" && (
                      <p className="text-danger">La longueur maximal est de 25 lettres</p>
                    )}
                    {errors?.email?.type === "pattern" && (
                      <p className="text-danger">Entrez un email valide</p>
                    )}
          </Form.Group>

          <Form.Group className="mb-3 position-relative" controlId="formBasicPassword">
            <Form.Label>mot de pass</Form.Label>
            <Form.Control
              {...register("password")}
              type={passwordShown ? "text" : "password"}

              placeholder="Password"
            />
              {
                  passwordShown === false ?
                  < AiFillEye
                    className="position-absolute eye"
                    onClick={togglePasswordVisiblity}
                    size={20}
                  />
                  :
                  <FaEyeSlash
                  className="position-absolute eye"
                  onClick={togglePasswordVisiblity}
                  size={20}
                  />
                }

          </Form.Group>

          <Form.Group className="mb-3 position-relative" controlId="formBasicPassword">
            <Form.Label>Confirmation mot de passe</Form.Label>
            <Form.Control
              {...register("confirmPassword")}
              type={passwordShowns ? "text" : "password"}

              placeholder="confirmation password"
            />
            {
                  passwordShowns === false ?
                  < AiFillEye
                    className="position-absolute eye"
                    onClick={togglePasswordVisiblitys}
                    size={20}
                  />
                  :
                  <FaEyeSlash
                  className="position-absolute eye"
                  onClick={togglePasswordVisiblitys}
                  size={20}
                  />
                }

          </Form.Group>
          <ToastContainer />
          <button type="submit" className="block-btn">
            S'inscrire
          </button>
        </Form>
      </div>
    </div>
  );
}
